export default "__VITE_ASSET__d68ba5db__"